import React, { forwardRef, useImperativeHandle } from 'react';
import { Col } from 'reactstrap'
import TemplateCanvas from './templateCanvas';

const Previews = forwardRef(({
  backgroundImage,
  backgroundCoverImage,
  texts,
  onChangeText,
  isTextRectShown,
  isUpdatingTemplate,
}, ref) => {
  const templateCanvasRefFr = React.useRef();
  const templateCanvasRefEn = React.useRef();

  useImperativeHandle(ref, () => ({
    async getCanvasImage(lang) {
      return new Promise(async (resolve, reject) => {
        if (lang === 'fr') {
          resolve(await templateCanvasRefFr.current.getCanvasImage());
        }
        resolve(await templateCanvasRefEn.current.getCanvasImage());
      });
    },
    async getTextHeight(lang, index) {
      return new Promise(async (resolve, reject) => {
        if (lang === 'fr') {
          resolve(await templateCanvasRefFr.current.getTextHeight(index));
        }
        resolve(await templateCanvasRefEn.current.getTextHeight(index));
      });
    },
  }));

  return (
    <Col className="container_previews">
      <h4>Previews</h4>
      <TemplateCanvas
        lang='en'
        backgroundImage={backgroundImage}
        backgroundCoverImage={backgroundCoverImage}
        texts={texts}
        onChangeText={onChangeText}
        isTextRectShown={isTextRectShown}
        ref={templateCanvasRefEn}
        isUpdatingTemplate={isUpdatingTemplate}
      />
      <TemplateCanvas
        lang='fr'
        backgroundImage={backgroundImage}
        backgroundCoverImage={backgroundCoverImage}
        texts={texts}
        onChangeText={onChangeText}
        isTextRectShown={isTextRectShown}
        ref={templateCanvasRefFr}
        isUpdatingTemplate={isUpdatingTemplate}
      />
    </Col>
  )
});

export default Previews;



// WEBPACK FOOTER //
// ./src/components/templates/previews.js